import React, { Component } from 'react';
import { Container, Row, Col, Badge } from 'reactstrap';
import api from '../services/api';

class ServiceList extends Component {
    constructor(props) {
        super(props);
        this.state = {
            services: [],
        };
    };

    componentDidMount() {
        this.resetState();
    }

    resetState = () => {
        this.getServices();
    };

    getServices = () => {
        return api.get('/services/')
            .then(res => {
                const sortedServices = res.data.sort((a, b) => a.sortorder - b.sortorder);

                // Append the static "Custom Time" service
                const customService = { id: 999, title: 'Custom', sortorder: Infinity, color_code: 'grey' };
                const updatedServices = [...sortedServices, customService];

                this.setState({ services: updatedServices });
            })
            .catch(err => console.log(err));
    };

    render() {
        return (
            <Container className="mt-4">
                <Row>
                    {this.state.services.map(service => (
                        <Col key={service.id} xs={12} md={6} lg={4}>
                            <div className="d-flex align-items-center p-1">
                                <Badge
                                    color={service.color_code}
                                    pill={false}
                                    style={{ backgroundColor: service.color_code, width: '20px', height: '20px', borderRadius: '4px', marginRight: '10px' }}> </Badge>
                                <span className="small">{service.title}</span>
                            </div>
                        </Col>
                    ))}
                </Row>
                <Row>
                    <Col xs={12} md={6} lg={4} className="mt-2">
                        <small className="text-muted fw-bold">
                            ** Locked
                        </small>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ServiceList;
